import React, { PureComponent } from 'react';
import { Button, Stepper, Step, StepLabel, TextField } from '@mui/material';
import Tile from '../../../../common/components/Tile/Tile';

class DesktopSharing extends PureComponent {
  render() {
    return (
      <Tile className="u-mb-full" title="Desktop sharing" helpTag="desktop_sharing">
        <div>
          <Button
            variant="contained"
            data-qa="qa-startDesktopSharingButton"
            color="primary"
            onClick={this.props.startDesktopSharing}
            disabled={!this.props.startIsEnabled}
          >
            Start
          </Button>

          <Button
            variant="contained"
            className="u-ml-full"
            data-qa="qa-cancelDesktopSharingButton"
            color="secondary"
            onClick={this.props.stopDesktopSharing}
            disabled={!this.props.cancelIsEnabled}
          >
            Cancel
          </Button>
          <span className="u-ml-full">Session ID: </span>
          <TextField
            value={this.props.sessionId}
            disabled
            data-qa="qa-sessionId"
            variant="standard"
          />
        </div>
        <div>
          <Stepper className="u-mt-full" activeStep={this.props.activeSharingStep}>
            {this.props.sharingSteps.map((step, index) => {
              return (
                <Step key={index} data-qa="qa-step-label">
                  <StepLabel>{step.label}</StepLabel>
                </Step>
              );
            })}
          </Stepper>
        </div>
      </Tile>
    );
  }
}

export default DesktopSharing;
